import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';
import { Select, Input } from 'antd';
import style from './index.scss';
import { getKeys } from '../utils';

const { Option } = Select;
const { Search } = Input;

function SearchComponent(props) {
  const defaultSearchParameter = { label: 'Search by', value: '' };
  const [searchableKeys, setSearchableKeys] = useState([]);
  const [searchParameter, setSearchParameter] = useState(
    defaultSearchParameter
  );
  const [searchError, setSearchError] = useState(null);
  const [inputSearchValue, setInputSearchValue] = useState('');
  const { widgetItemOperations } = props;

  useEffect(() => {
    getSearchableKeys();
  }, [widgetItemOperations]);

  const getSearchableKeys = () => {
    if (widgetItemOperations) {
      const searchableKeysArray = getKeys(widgetItemOperations, 'isSearchable');
      setSearchableKeys(searchableKeysArray);
    }
  };

  const onSelectHandleChange = (option) => {
    if (option.label == 'Search by' || option.value) {
      setSearchError(null);
    }
    setSearchParameter(option);
    if (option.label == 'Search by') {
      setInputSearchValue('');
      const searchObj = {
        search: []
      };
      props.applyFilterHandler(searchObj);
    }
  };

  const renderSelectDropdown = () => {
    if (!searchableKeys) return;
    const searchByOption = { itemLabel: 'Search by', itemName: '' };
    const optionsArray = [searchByOption, ...searchableKeys];
    const defaultKeyValue = { value: '' };
    return (
      <div className={style.item}>
        <Select
          defaultValue={defaultKeyValue}
          style={{ width: 130 }}
          labelInValue
          onChange={onSelectHandleChange}>
          {optionsArray.map((item) => {
            // FIN-6612: Custom label mapping for search fields
            const labelMap = {
              partyIdNo: 'Identification Number',
              transactionId: 'Transaction ID',
              partyId: 'Party ID'
            };
            const itemLabel =
              item.itemLabel == 'Search by'
                ? item.itemLabel
                : labelMap[item.itemName] || startCase(item.itemName);
            const itemName = item.itemName;
            return (
              <Option key={itemName} value={itemName}>
                {itemLabel}
              </Option>
            );
          })}
        </Select>
      </div>
    );
  };

  const onSearchHandler = (value) => {
    // Check if search value meets the minimum length requirement
    if (searchParameter.label !== 'Search by' && value.length < 3) {
      setSearchError('Enter min 3 characters to search');
      return; // Exiting early if validation fails
    }

    // Proceed only if search parameter label is valid
    if (searchParameter.label) {
      // FIN-6612: Use the field name directly - backend handles column mapping
      // Backend maps: partyId -> primaryPartyKey, partyName -> primaryPartyName,
      // transactionId -> transactionKey
      const columnName = searchParameter.value;

      // Prepare the search object
      const searchObj = {
        search:
          searchParameter.label !== 'Search by'
            ? [{ columnName, logic: 'like', value }]
            : []
      };

      props.applyFilterHandler(searchObj);
    }
  };

  const onInputChangeHandler = (e) => {
    setInputSearchValue(e.target.value);
    if (searchParameter.label == 'Search by') {
      setSearchError('Select search parameter');
      setInputSearchValue('');
    } else if (
      !e.target.value ||
      (e.target.value && e.target.value.length < 3)
    ) {
      setSearchError('Enter min 3 characters to search');
    } else {
      setSearchError(null);
    }
  };

  const renderInputSearch = () => {
    const isSearchDisabled =
      searchParameter?.label === 'Search by' || searchParameter?.value === '';
    return (
      <Search
        placeholder="Search"
        onSearch={onSearchHandler}
        enterButton
        onChange={onInputChangeHandler}
        value={inputSearchValue}
        disabled={isSearchDisabled}
      />
    );
  };

  return (
    <div className={style.wrapper}>
      <p className={style.iconLabel}>Search</p>
      <div className={style.flexSearchContainer}>
        {renderSelectDropdown()}
        {renderInputSearch()}
      </div>
      <span className={style.searchError}>{searchError}</span>
    </div>
  );
}

SearchComponent.propTypes = {
  widgetItemOperations: PropTypes.object.isRequired,
  applyFilterHandler: PropTypes.func.isRequired
};

export default SearchComponent;
